export default "__VITE_ASSET__BOs0SRUB__"